import { FC, useRef, useMemo, useReducer } from 'react'
import { isOkForHydration } from '@utils'
import { environment } from '@dmi-mch/utils'

import { reducer, StateContext } from './Context'

 const ModuleProvider: FC = (props) => {
  const { children, ...rest }:{ children?: any, rest?: any } = props

  const initialState = useMemo(() => ({
    //@ts-ignore
    CMSProps: rest.CMSProps,
    catalogArtworksList: [],
    activeTab: 'overview',
    isLoadingList: false,
    isLoadingNewpage: false,
    labels: null,
    galleryProfileData: null,
    state: {
      list: []
    }
  }), [rest])

  const refs = {
    paginationInfo: useRef(null),
    loadNextPageRef: useRef(null),
    activeFiltersRef: useRef(null),
    pushFullChange: useRef(null)
  }

  const [state, dispatch] = useReducer(reducer, initialState)

  useMemo(() => {
    if (isOkForHydration(state, initialState)) {
      environment.isNotPro &&
        // eslint-disable-next-line no-console
        console.error(
          'Attention, the initial state configured here and the one declared in' +
          ' ../contexts/module does not match. Remember to update and to add the explanation of what is, what for, ' +
          'and where is used, inside module context file.'
        )
    }
  }, [initialState, state])

  return (
    <StateContext.Provider value={{ state, dispatch, refs }}>{children}</StateContext.Provider>
  )
}

export default ModuleProvider